import _ from 'lodash'
import { setHistoryStack, getHistoryStack } from '@/utils/storage'

class HistoryStack {
    /**
     * stack 是模仿浏览器的历史记录实现的栈。
     */
    stack = []
    /**
     * records 是记录浏览过的 view， 从而判断是否已经加载过改 view。
     * 借助这个来优化切面切换时候的行为，减少不必要的动作。
     */
    records = {}

    constructor () {
        this.stack = getHistoryStack() || []
    }
    /**
     * 将路由压入历史记录的栈
     * @param route 路由
     */
    push (route) {
        this.stack.push(route)
        setHistoryStack(this.stack)
    }
    /**
     * 将最后一个路由记录出栈
     */
    pop () {
        const route = this.stack.pop()
        setHistoryStack(this.stack)
        return route
    }
    /**
     * 是否访问过该路由
     * @param route 路由
     */
    isVisited (route) {
        return this.records[route.name]
    }
    /**
     * 记录下该路由（注意和栈的区别）
     * @param route 路由
     */
    cache (route) {
        this.records[route.name] = route
    }
    /**
     * 历史记录栈里面是否存在该路由
     * @param route 路由
     */
    has (route) {
        return _.some(this.stack, record => {
            return route.fullPath === record.fullPath
        })
    }
    /**
     * 将历史记录栈直接回退到某个路由上。
     * @param route 路由
     */
    back (route) {
        const index = this.indexOf(route)
        this.stack = this.stack.slice(0, index + 1)
        setHistoryStack(this.stack)
    }
    /**
     * 获取历史记录栈的长度
     */
    length () {
        return this.stack.length
    }
    /**
     * 获取路由在历史记录栈上面的位置
     * @param route 路由
     */
    indexOf (route) {
        return _.findIndex(this.stack, record => {
            return route.fullPath === record.fullPath
        })
    }
    /**
     * 更新历史记录栈上的某个路由
     * @param route 路由
     */
    update (route) {
        const index = _.findIndex(this.stack, stackRoute => {
            return stackRoute.fullPath === route.fullPath
        })
        if (index > -1) {
            this.stack[index] = route
            setHistoryStack(this.stack)
        }
    }
    /**
     * 获取历史记录栈上最后一个记录
     */
    last () {
        return _.last(this.stack)
    }
    /**
     * 该路由是否是历史记录栈上的最后一个
     * @param route 路由
     */
    isLast (route) {
        return this.indexOf(route) === this.stack.length - 1
    }
    /**
     * 获取需要缓存的页面组件（page component）名称。
     */
    getKeepAliveViewsName () {
        const keepAliveViews = _.filter(this.stack, route => {
            return route['meta'] && route.meta.keepAlive !== false
        })
        return _.map(keepAliveViews, route => {
            return route.meta.cacheName
        }).join(',')
    }
    /**
     * 获取不需要缓存的页面组件（page component）名称。
     */
    getNoKeepAliveViewsName () {
        const keepAliveViews = _.filter(this.stack, route => {
            return route['meta'] && route.meta.keepAlive === false
        })
        return _.map(keepAliveViews, route => {
            return route.meta.cacheName
        }).join(',')
    }
}

export default HistoryStack
